import MyMoveConfirmation from "@/views/my-move-confirmation.vue";

export enum RouteNames {
    Home = 'home',
    Test = 'test',
    LoadingPage = 'loading-page',
    EnergyPlanSelection = 'energy-plan-selection',
    TvPlanSelection = 'tv-plan-selection',
    MiniBoxSelection = 'mini-box-selection',
    StreamingSelection = 'streaming-plan-selection',
    SimSelection = 'sim-cards-selection',
    Quiz = 'quiz',
    MarketingPreferanceReview = 'marketing-preferance-review',
    OrderSummary = 'order-summary',
    BroadbandPlanSelection = 'broadband-plan-selection',
    WastePlans = 'waste-plans',
    SecurityPlans = 'security-plans',
    SecurityPlansAddon = 'security-plans-addon',
    OrderStatus = 'order-status',
    ErrorPage = 'error-page',
    RenewalProperty = 'renewal-your-property',
    RenewalExistingContract = 'renewal-existing-contract',
    RenewalMeterRead = 'renewal-meter-read',
    RenewalMovedProperty = 'renewal-moved-address-error',
    MyMoveSecurity = 'my-move-security',
    MyMoveConfirmation = 'my-move-confirmation'
}